
<router-outlet></router-outlet>
<div class="position-fixed bottom-0 start-0 w-100" style="z-index: 2000">
  <div id="errorToast" class="toast w-100 bg-danger position-relative bg-opacity-75" data-bs-animation="true" data-bs-delay="3000" role="alert">
    <div class="toast-body text-center text-white fs-5">
      <p class="m-0" id="toastMsg"></p>
    </div>
  </div>
</div>

<div class="position-fixed bottom-0 start-0 w-100" style="z-index: 2000">
  <div id="successToast" class="toast w-100 bg-success position-relative bg-opacity-75" data-bs-animation="true" data-bs-delay="3000" role="alert">
    <div class="toast-body text-center text-white fs-5">
      <p class="m-0" id="successToastMsg"></p>
    </div>
  </div>
</div>
